export const COMMENT_ANCHOR_PREFIX_WITHOUT_HASH = "comment_wrapper_";
export const COMMENT_ANCHOR_PREFIX = `#${COMMENT_ANCHOR_PREFIX_WITHOUT_HASH}`;

export const DISABLED_EDITOR_EXTENSIONS = ["poll", "ai_copilot", "cta"];
